<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		:width="width"
		:height="height"
		fill="currentColor"
		class="ki ki-chevron-up"
		viewBox="0 0 24 24"
	>
		<path d="M12,6.6l9.4,9.4L20,17.4l-8-8l-8,8L2.6,16L12,6.6z" />
	</svg>
</template>

<script setup lang="ts">
interface Props {
	width?: number;
	height?: number;
}
withDefaults(defineProps<Props>(), {
	width: 24,
	height: 24
});
</script>
